import React from "react";
import { Navigate } from "react-router-dom";
// import jwtDecode from "jwt-decode";
import { jwtDecode } from "jwt-decode";
import { secureStorage } from "./utils/secureStorage";

const isTokenValid = () => {
  const token = secureStorage.getItem("token");
  if (!token) return false;

  try {
    const decoded = jwtDecode(token);
    const currentTime = Math.floor(Date.now() / 1000);
    return decoded.exp > currentTime;
  } catch (err) {
    console.error("Invalid token:", err);
    return false;
  }
};

const AuthGate = ({ children }) => {
  const authenticated = isTokenValid();

  if (!authenticated) {
    return <Navigate to="/login" replace />;
  }

  return children;
};

export default AuthGate;
